import { ApIcon, colors } from '@alixpartners/ui-components';
import React from 'react';
import { Tooltip } from 'react-tippy';

import { SummaryBarChart } from './SummaryBarChart';
import { SummaryChart } from './SummaryChart';

import {
	Wrapper,
	BlockLabel,
	BlockValue,
	Block,
	BlockSeparator,
	BlockGroup,
	BottomSection,
	BlockValuePercent,
	VerticalLayoutWrapper,
	ChartWrapper,
	IconWrapper,
} from './InitiativesSummary.styles';

export const InitiativesSummary = ({
	data,
	currencySymbol,
	isPaymentTerms,
}) => {
	const {
		totalValue,
		spend,
		addressable,
		addressablePercentage,
		low,
		lowPercentage,
		high,
		highPercentage,
		chartData,
		paymentTermsChartData,
		totalSpendDateFrom,
		totalSpendDateTo,
		initiativeSpendDateFrom,
		initiativeSpendDateTo,
	} = data;
	const chartWidth = isPaymentTerms ? '360px' : '280px';
	const lowTitle = isPaymentTerms
		? 'Working capital impact - Low'
		: 'Low end savings';
	const highTitle = isPaymentTerms
		? 'Working capital impact - High'
		: 'High end savings';
	const showAddressableBlock = !isPaymentTerms;

	return (
		<Wrapper>
			<VerticalLayoutWrapper>
				<BlockGroup>
					<Block>
						<BlockLabel>
							Total spend
							<Info content="Total spend includes sourceable and non-sourceable spend" />
						</BlockLabel>
						<BlockValue>{totalValue}</BlockValue>
					</Block>
					<Block>
						<BlockLabel>
							Initiatives coverage
							<Info content="Initiative coverage includes sourceable spend only" />
						</BlockLabel>
						<BlockValue>{spend}</BlockValue>
					</Block>

					<BlockSeparator />

					{showAddressableBlock && (
						<Block>
							<BlockLabel>Sourceable</BlockLabel>
							<BlockValue>
								{addressable}
								<BlockValuePercent>
									({addressablePercentage}%)
								</BlockValuePercent>
							</BlockValue>
						</Block>
					)}
					<Block>
						<BlockLabel>{lowTitle}</BlockLabel>
						<BlockValue>
							{low}
							<BlockValuePercent>({lowPercentage || '0'}%)</BlockValuePercent>
						</BlockValue>
					</Block>
					<Block>
						<BlockLabel>{highTitle}</BlockLabel>
						<BlockValue>
							{high}
							<BlockValuePercent>({highPercentage || '0'}%)</BlockValuePercent>
						</BlockValue>
					</Block>

					<BlockSeparator white />
				</BlockGroup>
				<BottomSection>
					<ApIcon
						iconName="baseline_date_range"
						iconSize={16}
						iconColor={colors.grey5}
					/>
					<span>
						Total spend time period: {totalSpendDateFrom}–{totalSpendDateTo}
					</span>
					<span>
						Initiatives default time period: {initiativeSpendDateFrom}–{
							initiativeSpendDateTo
						}
					</span>
				</BottomSection>
			</VerticalLayoutWrapper>

			<ChartWrapper width={chartWidth}>
				{isPaymentTerms ? (
					<SummaryBarChart
						data={paymentTermsChartData || []}
						currencySymbol={currencySymbol}
					/>
				) : (
					<SummaryChart data={chartData} />
				)}
			</ChartWrapper>
		</Wrapper>
	);
};

export const Info = ({ content }) => {
	return (
		<Tooltip
			position="bottom"
			animation="fade"
			arrow
			html={content}
			trigger="mouseenter"
		>
			<IconWrapper>
				<ApIcon
					iconName="baseline_help"
					iconSize={12}
					iconColor={colors.grey6}
				/>
			</IconWrapper>
		</Tooltip>
	);
};

export default InitiativesSummary;
